import { postAiProfile, postTrainingGame } from '../onlineApi';
import { listUnsyncedCompletedGames, listUnsyncedProfiles, markProfileSynced, markTrainingGameSynced } from './trainingQueue';

export async function syncTrainingData(guestToken: string): Promise<{ uploaded: number }> {
  if (!guestToken) return { uploaded: 0 };
  const profiles = await listUnsyncedProfiles(10);
  const batch = await listUnsyncedCompletedGames(10);
  let uploaded = 0;
  for (const profile of profiles) {
    await postAiProfile(guestToken, profile);
    await markProfileSynced(profile.id);
    uploaded += 1;
  }
  for (const game of batch) {
    await postTrainingGame(guestToken, game);
    await markTrainingGameSynced(game.id);
    uploaded += 1;
  }
  return { uploaded };
}
